import {
  AlertDialog,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useDisclosure,
  AlertDialogBody,
  Input,
  Text,
  useToast,
  Flex,
} from '@chakra-ui/react'
import { zodResolver } from '@hookform/resolvers/zod'
import React, { useCallback, useState } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { api } from '../../../services/api'
import { useMutation, useQueryClient } from 'react-query'
import { useUser } from '../../../hooks/useUser'

async function onValidate(data) {
  const res = await api.post('/site/v2/fiscal/validar-nota-sefaz', data)

  return res.data
}

export function Validar({ numero_pedido, pedido }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()

  const [bipes, setBipes] = useState([])

  const queryClient = useQueryClient()

  const toast = useToast({
    position: 'top-right',
  })

  function addNewBipe() {
    setBipes((prev) => [...prev, ''])
  }

  function updateBipe(index, value) {
    setBipes((prev) => prev.map((item, i) => (i === index ? value : item)))
  }

  function removeBipe(index) {
    setBipes((prev) => prev.filter((_, i) => i !== index))
  }

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: onValidate,
    onSuccess: () => {
      toast({
        title: 'Nf validada com sucesso!',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })

      queryClient.invalidateQueries('nfData')

      onClose()
    },
    onError: () => {
      toast({
        title: 'Erro ao validar NF!',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  async function onSubmit(data) {
    const params = {
      chave_nota: bipes,
      numero_pedido,
      numero_nota: pedido,
      pedido_compra: pedido,
    }

    await mutateAsync(params)
  }

  return (
    <>
      <Button size="xs" colorScheme="green" onClick={onOpen}>
        Validar
      </Button>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Validar nota fiscal
            </AlertDialogHeader>

            <AlertDialogBody>
              <AlertDialogBody>
                Por favor, bipe a nota fiscal para validar.
                {bipes.map((bipe, index) => (
                  <Flex key={index} gap={2} alignItems="center" mt={2}>
                    <Input value={bipe} placeholder="Bipe a nota fiscal" onChange={(e) => updateBipe(index, e.target.value)} />
                    <Button colorScheme="red" onClick={() => removeBipe(index)}>
                      Remover
                    </Button>
                  </Flex>
                ))}
                <Button colorScheme="blue" onClick={addNewBipe} mt={2}>
                  Adicionar
                </Button>
              </AlertDialogBody>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button isLoading={isLoading} onClick={onSubmit} colorScheme="green" ml={3}>
                Validar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
